import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfDay, endOfDay, subMonths, subWeeks } from 'date-fns';
import { IVigoDateRangeReturn } from 'src/@vigo/vigo-daterange';

export const calculateRange = (option: string, nv: any) => {
  let startDate = new Date();
  let endDate = new Date();
  let rangeText = '';

  // Check for custom date (e.g Wed May 17 2023 - Fri May 19 2023)
  if (option.indexOf(' - ') > 1) return buildCustomResponse(option);

  // calculate the date range based on selected values
  switch (option.replaceAll('"', '')) {
    case 'Tomorrow': {
      const tomorrowDate = new Date();
      tomorrowDate.setDate(tomorrowDate.getDate() + 1);
      startDate = tomorrowDate;
      endDate = tomorrowDate;
      break;
    }

    case 'Yesterday': {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      rangeText = 'Yesterday';
      startDate = startOfDay(date);
      endDate = endOfDay(date);
      break;
    }

    case 'This Week':
      rangeText = 'This Week';
      startDate = startOfWeek(new Date(), { weekStartsOn: 1 });
      endDate = endOfWeek(new Date(), { weekStartsOn: 1 });
      break;

    case 'Next Week': // next week
      rangeText = 'Next Week';
      startDate = startOfWeek(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      endDate = endOfWeek(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      break;

    case 'Last Week': // last week
      rangeText = 'Last Week';
      startDate = startOfWeek(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      endDate = endOfWeek(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      break;

    case 'Week Before Last':
      rangeText = 'Week Before Last';
      startDate = startOfWeek(new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      endDate = endOfWeek(new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      break;

    case 'Last 2 Weeks': // last two weeeks
      rangeText = 'Last 2 Weeks';
      startDate = startOfWeek(new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      endDate = endOfWeek(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      break;

    case 'Previous 2 Week Period': {
      // 2 week period before last 2 weeks
      rangeText = 'Previous 2 Week Period';
      const startOfLast2Weeks = startOfWeek(new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      const lastDayOfPreviousPeriod = endOfWeek(subWeeks(startOfLast2Weeks, 1), { weekStartsOn: 1 });
      startDate = startOfWeek(subWeeks(lastDayOfPreviousPeriod, 1), { weekStartsOn: 1 });
      endDate = lastDayOfPreviousPeriod;
      break;
    }

    case 'Last 3 Weeks': // last three weeks
      rangeText = 'Last 3 Weeks';
      startDate = startOfWeek(new Date(Date.now() - 21 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      endDate = endOfWeek(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      break;

    case 'Previous 3 Week Period': {
      // 3 week period before last 3 weeks
      rangeText = 'Previous 3 Week Period';
      const startOfLast3Weeks = startOfWeek(new Date(Date.now() - 21 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      (() => {
        const lastDayOfPreviousPeriod = endOfWeek(subWeeks(startOfLast3Weeks, 1), { weekStartsOn: 1 });
        startDate = startOfWeek(subWeeks(lastDayOfPreviousPeriod, 2), { weekStartsOn: 1 });
        endDate = lastDayOfPreviousPeriod;
      })();
      break;
    }

    case 'Last 4 Weeks': // last 4 weeks
      rangeText = 'Last 4 Weeks';
      startDate = startOfWeek(new Date(Date.now() - 28 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      endDate = endOfWeek(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      break;

    case 'Previous 4 Week Period': {
      // 4 week period before last 4 weeks
      rangeText = 'Previous 3 Week Period';
      const startOfLast4Weeks = startOfWeek(new Date(Date.now() - 28 * 24 * 60 * 60 * 1000), { weekStartsOn: 1 });
      (() => {
        const lastDayOfPreviousPeriod = endOfWeek(subWeeks(startOfLast4Weeks, 1), { weekStartsOn: 1 });
        startDate = startOfWeek(subWeeks(lastDayOfPreviousPeriod, 3), { weekStartsOn: 1 });
        endDate = lastDayOfPreviousPeriod;
      })();
      break;
    }

    case 'This Month': // this month
      rangeText = 'This Month';
      startDate = startOfMonth(new Date());
      endDate = endOfMonth(new Date());
      break;

    case 'Last 3 Months': {
      // last three months
      rangeText = 'Last 3 Months';
      const fd = new Date();
      fd.setMonth(fd.getMonth() - 2);
      const ld = new Date();
      ld.setMonth(ld.getMonth());
      startDate = startOfMonth(fd);
      endDate = endOfMonth(ld);
      break;
    }

    case 'Previous 3 Months': {
      // The 3 months before last 3 months
      rangeText = 'Previous 3 Months';
      const firstDayOfLast3Months = new Date();
      firstDayOfLast3Months.setMonth(firstDayOfLast3Months.getMonth() - 2);
      const startOfLast3MonthPeriod = startOfMonth(firstDayOfLast3Months);
      const lastDayOfPrevious3MonthPeriod = endOfMonth(subMonths(startOfLast3MonthPeriod, 1));
      startDate = startOfMonth(subMonths(lastDayOfPrevious3MonthPeriod, 2));
      endDate = lastDayOfPrevious3MonthPeriod;
      break;
    }

    case 'Next Month': {
      // this month
      rangeText = 'Next Month';
      const ld2 = new Date();
      ld2.setMonth(ld2.getMonth() + 1);
      startDate = startOfMonth(ld2);
      endDate = endOfMonth(ld2);
      break;
    }

    case 'Last Month': {
      // Last month
      rangeText = 'Last Month';
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      startDate = startOfMonth(lastMonth);
      endDate = endOfMonth(lastMonth);
      break;
    }

    case 'Month Before Last': {
      rangeText = 'Month Before Last';
      const monthBeforeLast = new Date();
      startDate = startOfMonth(subMonths(monthBeforeLast, 2));
      endDate = endOfMonth(subMonths(monthBeforeLast, 2));
      break;
    }

    case 'Next 3 Months': {
      // last three months
      rangeText = 'Next 3 Months';
      const fd1 = new Date();
      fd1.setMonth(fd1.getMonth());
      const ld1 = new Date();
      ld1.setMonth(ld1.getMonth() + 2);
      startDate = startOfMonth(fd1);
      endDate = endOfMonth(ld1);
      break;
    }

    case 'Custom': // custom range
      startDate = nv[0] ? startOfDay(nv[0]) : new Date();
      endDate = nv[1] ? endOfDay(nv[1]) : new Date();
      rangeText = `${startDate.toDateString()} - ${endDate.toDateString()}`;
      break;

    default:
      rangeText = 'Today';
      startDate = new Date();
      endDate = new Date();
      break;
  }

  const returnData: IVigoDateRangeReturn = {
    dateFrom: startOfDay(startDate),
    dateTo: endOfDay(endDate),
    selectedRange: rangeText
  };

  return returnData;
};

const buildCustomResponse = (option: string): IVigoDateRangeReturn => {
  const [dateFrom, dateTo] = option.replaceAll('"', '')?.split(' - ') ?? [startOfDay(new Date()), endOfDay(new Date())];

  return {
    dateFrom: startOfDay(new Date(dateFrom)),
    dateTo: endOfDay(new Date(dateTo)),
    selectedRange: `${new Date(dateFrom).toDateString()} - ${new Date(dateTo).toDateString()}`
  };
};
